export const SettingsToolTypes = ['Bridges', 'Exchanges'];
